"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _beautyStoreQuery = require("./beautyStoreQuery");
Object.keys(_beautyStoreQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _beautyStoreQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _beautyStoreQuery[key];
    }
  });
});
var _searchPreview = require("./searchPreview");
Object.keys(_searchPreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _searchPreview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _searchPreview[key];
    }
  });
});